import React, { useState } from 'react';
import ClickAwayListener from '@mui/base/ClickAwayListener';
// Components
import DownArrow from 'assets/images/svg/DownArrow';

/**
 * Pill shaped "Label Value ▾" filter used across the orders filter bar. The syncfusion
 * CustomSelect carries its own 51px bordered look, which the filter bar design doesn't
 * use, so these lightweight dropdowns are rendered instead.
 */
const FilterDropdown = ({ id, label, options, value, onSelect, disabled, placeholder }) => {
  const [isOpen, setIsOpen] = useState(false);
  const selected = options.find((option) => option.value === value);

  const handleSelect = (option) => {
    setIsOpen(false);
    onSelect(option);
  };

  return (
    <ClickAwayListener onClickAway={() => setIsOpen(false)}>
      <div className={`filter-dropdown${disabled ? ' disabled' : ''}`} id={id}>
        <button
          type="button"
          className="filter-dropdown-trigger"
          disabled={disabled}
          onClick={() => setIsOpen((prev) => !prev)}
        >
          {label && <span className="filter-dropdown-label">{label}</span>}
          <span className="filter-dropdown-value">{selected?.text ?? placeholder}</span>
          <DownArrow customCss={`filter-dropdown-caret${isOpen ? ' upside-down' : ''}`} />
        </button>

        {isOpen && (
          <ul className="filter-dropdown-menu">
            {options.length === 0 && <li className="empty">No options</li>}
            {options.map((option) => (
              <li
                key={option.value}
                className={option.value === value ? 'active' : ''}
                onClick={() => handleSelect(option)}
              >
                {option.text}
              </li>
            ))}
          </ul>
        )}
      </div>
    </ClickAwayListener>
  );
};

export default FilterDropdown;
